import { render } from "./ProduitColisPostauxPage.vue?vue&type=template&id=6af0dfa8"
import script from "./ProduitColisPostauxPage.vue?vue&type=script&lang=js"
export * from "./ProduitColisPostauxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__